import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import Api from '../../../../../services/Api';
import Button from '../../../../atoms/Button/Button';
import Icon from '../../../../atoms/Icon/Icon';
import ContextTypeSelector from '../../../../atoms/ContextsTypeSelector/ContextTypeSelector';
import './CreateContextModal.scss';

const CreateContextModal = ({
  onItemCreated,
  cityId,
  dynastyId,
}) => {
  const [typeId, setTypeId] = useState(undefined);
  const [name, setName] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const saveComponent = () => {
    if (!typeId) {
      setError('Element type is required');
      return;
    }
    if (!name) {
      setError('Element name is required');
      return;
    }
    setLoading(true);
    Api.post('instances/building-contexts', {
      name,
      code_suffix: 'SCN',
      dynasty_id: dynastyId,
      city_id: cityId,
      context_type_id: typeId,
    }).then((response) => {
      setLoading(false);
      onItemCreated(response.data);
    });
  };
  return (
    <Row>
      <Col md={12}>
        <FormGroup>
          <Label>Type</Label>
          <ContextTypeSelector onChanged={e => setTypeId(e.value)} isMulti={false} />
        </FormGroup>
      </Col>
      <Col md={12}>
        <FormGroup>
          <Label>Name</Label>
          <Input type="text" onChange={e => setName(e.target.value)} value={name} />
        </FormGroup>
      </Col>
      {error !== undefined && (
        <Col md={12} className="d-flex justify-content-end">
          <span className="text-danger">{error}</span>
        </Col>
      )}
      <Col className="d-flex justify-content-end mt-3">
        <Button isLoading={loading} onInvoked={() => saveComponent()}>
          <Icon icon="save" color="#fff" />
          <span className="ms-2">Save</span>
        </Button>
      </Col>
    </Row>
  );
};

CreateContextModal.propTypes = {
  onItemCreated: PropTypes.func.isRequired,
  cityId: PropTypes.number.isRequired,
  dynastyId: PropTypes.number.isRequired,
};

CreateContextModal.defaultProps = {

};

export default CreateContextModal;
